module.exports = __webpack_public_path__ + "static/media/alpha_6.d6e60ee0.png";